import React, { useEffect, useState } from "react";
import { PopupModal, useCalendlyEventListener } from "react-calendly";
import { useNavigate } from "react-router-dom";
import { roleBasedRedirection } from "../utils/helper";

const Calendy: React.FC<{
  onEventScheduled: (data: {
    name: string;
    email: string;
    preparationDetails: string;
    interviewID?: string | number;
    meetingLink?: string;
  }) => void;
  userId?: number;
  onScheduleBehavior?: "navigate" | "close";
  interviewID?: string | number;
  meetingLink?: string;
  onClose?: () => void;
}> = ({
  onEventScheduled,
  userId,
  onScheduleBehavior,
  interviewID,
  meetingLink,
  onClose,
}) => {
  const [isModalOpen, setModalOpen] = useState(true);
  const navigate = useNavigate();

  const handleModalClose = () => {
    if (onScheduleBehavior === "navigate") {
      navigate(roleBasedRedirection("/candidate-leads-dashboard"), {
        state: { campaignID: userId },
      });
    } else if (onScheduleBehavior === "close") {
      setModalOpen(false);
    }
    onClose?.();
  };

  const handleEventScheduled = (eventData: any) => {
    if (onScheduleBehavior === "navigate") {
      navigate(roleBasedRedirection("/interview-proccess"), {
        state: { userId: interviewID },
      });
    } else if (onScheduleBehavior === "close") {
      setModalOpen(false);
    }
    onClose?.();
    // Log event data for now (modify this as needed)

    // Accessing user details from eventData if available
    const name = eventData?.payload?.invitee?.name || "N/A";
    const email = eventData?.payload?.invitee?.email || "N/A";
    const preparationDetails =
      eventData?.payload?.questions_and_answers?.find((q: any) =>
        q.question.toLowerCase().includes("preparation")
      )?.answer || "None";

    // Log extracted data
    // Call onEventScheduled callback to pass the data
    onEventScheduled({ name, email, preparationDetails, interviewID });
  };

  // Use the hook to listen for the scheduled event
  useCalendlyEventListener({
    onEventScheduled: handleEventScheduled,
  });

  useEffect(() => {
    console.log("userId", userId);
  }, []);

  return (
    <div className="App">
      <PopupModal
        url={meetingLink || process.env.REACT_APP_CALANDY_URL || ""}
        rootElement={document.getElementById("root") as HTMLElement}
        pageSettings={{
          backgroundColor: "transparent",
          hideEventTypeDetails: false,
          hideLandingPageDetails: false,
          primaryColor: "00a2ff",
          textColor: "4d5055",
        }}
        onModalClose={handleModalClose}
        open={isModalOpen}
      />
    </div>
  );
};

export default Calendy;
